export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-16"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/30"></div>

      <div className="w-full px-4 md:px-6 relative z-10">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-10 md:py-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-800 rounded-full mb-4">
              2026暑期档 · 热映中
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              777影院
              <span className="block text-primary-500">高清影视在线观看平台</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              777影院午夜伦不卡致力于打造全网最流畅的高清影视平台。
              收录电影、电视剧、综艺、动漫、纪录片等全品类资源，每日更新热门新片，
              1080P超清画质配合CDN极速加速，让每一次观影都成为享受。
              无需注册，即点即看，纯粹观影从这里开始。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-500">60,000+</div>
                <div className="text-xs text-foreground-500">影视资源</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-600">每日更新</div>
                <div className="text-xs text-foreground-500">同步追剧</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-500">1080P/4K</div>
                <div className="text-xs text-foreground-500">高清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleScroll(e, '#carousel')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap text-center cursor-pointer"
              >
                开始观影
              </a>
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors duration-200 text-sm whitespace-nowrap text-center cursor-pointer"
              >
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-[540px]">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20theater%20interior%20with%20golden%20lighting%2C%20soft%20velvet%20textures%2C%20art%20deco%20decorative%20elements%2C%20elegant%20film%20projector%20silhouette%20in%20warm%20amber%20tones%2C%20atmospheric%20movie%20watching%20environment%2C%20rich%20dark%20and%20gold%20color%20palette%2C%20stylized%20artistic%20rendering%20with%20subtle%20grain%20texture%2C%20sophisticated%20luxury%20cinema%20aesthetic%2C%20cozy%20yet%20grand%20atmosphere%2C%20soft%20bokeh%20lighting%20effects&width=1080&height=810&seq=hero-main&orientation=landscape"
                alt="777影院高清影视在线观看平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                <span className="text-xs text-white/90 font-medium">每日更新 · 在线热播中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}